"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import Link from "next/link";
import type { GhostPost } from "@/lib/ghost";
import { getGhostPostExcerpt } from "@/lib/ghost";
import { ROUTES } from "@/lib/routes";
import { GridBorderedSection, GridDivider } from "./GridLayout";
export function BlogSection(t0) {
  const $ = _c(40);
  const {
    posts
  } = t0;
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const activeIndexRef = useRef(0);
  const cardWidthRef = useRef(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const container = scrollRef.current;
      if (!container || !container.children[0]) {
        return 0;
      }
      const w = (container.children[0] as HTMLElement).offsetWidth + 24;
      cardWidthRef.current = w;
      return w;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const measureCardWidth = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      const container_0 = scrollRef.current;
      if (!container_0) {
        return;
      }
      const card = container_0.children[index] as HTMLElement | undefined;
      if (!card) {
        return;
      }
      container_0.scrollTo({
        left: card.offsetLeft - container_0.offsetLeft,
        behavior: "smooth"
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const scrollToIndex = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const container_1 = scrollRef.current;
      if (!container_1) {
        return;
      }
      container_1.scrollBy({
        left: -(cardWidthRef.current || measureCardWidth()),
        behavior: "smooth"
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const scrollPrev = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const container_2 = scrollRef.current;
      if (!container_2) {
        return;
      }
      container_2.scrollBy({
        left: cardWidthRef.current || measureCardWidth(),
        behavior: "smooth"
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const scrollNext = t4;
  let t5;
  let t6;
  if ($[4] !== posts.length) {
    t5 = () => {
      const container_3 = scrollRef.current;
      if (!container_3) {
        return;
      }
      measureCardWidth();
      const onScroll = () => {
        const cardWidth = cardWidthRef.current;
        if (!cardWidth) {
          return;
        }
        const idx = Math.max(0, Math.min(Math.round(container_3.scrollLeft / cardWidth), posts.length - 1));
        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      };
      const handleResize = () => measureCardWidth();
      window.addEventListener("resize", handleResize);
      container_3.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => {
        container_3.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", handleResize);
      };
    };
    t6 = [posts.length, measureCardWidth];
    $[4] = posts.length;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>[</span>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = String(activeIndex + 1);
  let t9;
  if ($[8] !== t8) {
    t9 = t8.padStart(2, "0");
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <span className="text-ds-brand-600">{t9}</span>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = String(posts.length);
  let t12;
  if ($[12] !== t11) {
    t12 = t11.padStart(2, "0");
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12) {
    t13 = <span>/{t12}] LATEST POSTS</span>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t13) {
    t14 = <p className="text-ds-alpha-shadow-30 font-mono text-base font-medium">{t7}{t10}{t13}</p>;
    $[16] = t10;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <button onClick={scrollPrev} aria-label="Previous posts" className="border-ds-neutral-200 flex h-[47px] w-[104px] items-center justify-center border bg-white"><img alt="Previous" src="/images/homepage/icon-chevron-left.svg" className="size-6" /></button>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex items-start pr-px">{t15}<button onClick={scrollNext} aria-label="Next posts" className="border-ds-neutral-200 -ml-px flex h-[47px] w-[104px] items-center justify-center border bg-white"><img alt="Next" src="/images/homepage/icon-chevron-right.svg" className="size-6" /></button></div>;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t14) {
    t17 = <GridBorderedSection className="flex h-[120px]"><div className="mx-auto h-full w-full max-w-[1440px] px-[9px]"><div className="border-ds-neutral-200 flex h-full w-full items-center justify-between overflow-clip border-l border-r px-8">{t14}{t16}</div></div></GridBorderedSection>;
    $[21] = t14;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <GridDivider variant={2} />;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  let t20;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h2 className="text-ds-text-subtle leading-label text-4xl font-medium tracking-[-0.72px]">Dispatches from the control room.</h2>;
    t20 = <p className="text-ds-zinc-600 leading-30 text-xl">Product notes, launch logs, technical breakdowns, and operating memos from the team building B3OS.</p>;
    $[24] = t19;
    $[25] = t20;
  } else {
    t19 = $[24];
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="border-ds-neutral-200 flex flex-col justify-center gap-6 border-l px-8 py-12 lg:w-[400px] lg:shrink-0 lg:py-16">{t19}{t20}<div><Link href={ROUTES.BLOG} className="shadow-ds-white from-ds-neutral-100 to-ds-neutral-200 text-ds-text-primary relative inline-flex h-11 items-center gap-2 overflow-clip rounded-xl bg-gradient-to-b px-6 py-3 text-base font-medium transition-transform hover:scale-[1.02]">View All Posts<span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" /></Link></div></div>;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== posts) {
    t22 = posts.map(_temp);
    $[27] = posts;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== t22) {
    t23 = <div ref={scrollRef} className="scrollbar-hide flex gap-6 overflow-x-auto py-8 pl-6 lg:pl-12">{t22}</div>;
    $[29] = t22;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] !== activeIndex || $[32] !== posts) {
    t24 = posts.length > 1 ? <div className="flex items-center justify-center gap-2 pb-6">{posts.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} aria-label={`Go to post ${i + 1}`} className={`size-2 rounded-full transition-colors ${i === activeIndex ? "bg-ds-brand-600" : "bg-ds-neutral-200"}`} />)}</div> : null;
    $[31] = activeIndex;
    $[32] = posts;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t23 || $[35] !== t24) {
    t25 = <div className="mx-auto max-w-[1440px] px-[9px]"><div className="border-ds-neutral-200 lg:divide-ds-neutral-200 flex flex-col lg:flex-row lg:divide-x">{t21}<div className="border-ds-neutral-200 min-w-0 flex-1 border-r"><div className="flex flex-col">{t23}{t24}</div></div></div></div>;
    $[34] = t23;
    $[35] = t24;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== t17 || $[38] !== t25) {
    t26 = <section aria-label="Blog">{t17}{t18}{t25}</section>;
    $[37] = t17;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  return t26;
}
function _temp(post) {
  const excerpt = getGhostPostExcerpt(post);
  const dateStr = post.published_at ? format(new Date(post.published_at), "MMM d, yyyy") : null;
  return <Link key={post.id} href={`/blog/${post.slug}`} className="border-ds-neutral-200 shadow-xs group flex min-w-[320px] flex-col rounded-xl border bg-white transition-shadow hover:shadow-md md:min-w-[400px]">{post.feature_image ? <div className="p-2"><div className="border-ds-neutral-200 aspect-[2/1] w-full overflow-hidden rounded-md border"><img src={post.feature_image} alt={post.feature_image_alt ?? post.title} loading="lazy" className="h-full w-full object-cover" /></div></div> : null}<div className="flex flex-1 flex-col gap-2 p-6">{dateStr ? <p className="text-ds-brand-600 text-sm font-semibold">{dateStr}{post.reading_time ? ` · ${post.reading_time} min read` : null}</p> : null}<div className="flex items-start justify-between gap-2"><h3 className="text-ds-text-primary group-hover:text-ds-text-secondary text-lg font-semibold leading-7 transition-colors">{post.title}</h3><svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="text-ds-text-disabled group-hover:text-ds-text-subtle mt-0.5 shrink-0 transition-colors" aria-hidden="true"><path d="M5.833 14.167L14.167 5.833M14.167 5.833H7.5M14.167 5.833V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></div>{excerpt ? <p className="text-ds-text-subtle line-clamp-3 text-base leading-6">{excerpt}</p> : null}</div></Link>;
}